import uniqid from "uniqid";

import ProjectContainer from "../ProjectContainer/ProjectContainer.jsx";
import Reveal from "../Reveal/Reveal";
import { projects } from "../../data";

import "./projects.css";

const Projects = () => {
  if (!projects.length) return null;

  return (
    <section id="projects" className="section projects">
      <Reveal as="h2" className="section__title">
        Projects
      </Reveal>

      <ul className="projects__grid">
        {projects.map((project, i) => (
          <ProjectContainer key={uniqid()} project={project} index={i} />
        ))}
      </ul>
    </section>
  );
};

export default Projects;
